import { handleActions } from 'redux-actions';
import {
  companySuccess,
  enableVisitorLogSuccess,
  disableVisitorLogSuccess,
  ssoConfigurationSuccess,
  updateSSOConfigurationSuccess,
  enableSSOSuccess,
  disableSSOSuccess,
  enableBranchesSuccess,
  disableBranchesSuccess,
  updateMaxShiftHoursSuccess,
  switchGpsRequiredSuccess,
  enableChatSuccess,
  disableChatSuccess,
} from './actions';
import { logoutSuccess } from 'ducks/auth/actions';

import initialState from './states';

export default handleActions(
  {
    [companySuccess](state, { payload }) {
      return {
        ...state,
        info: {
          ...state.info,
          [payload.companyID]: payload,
        },
      };
    },
    [enableVisitorLogSuccess](state, { payload: companyID }) {
      return {
        ...state,
        info: {
          ...state.info,
          [companyID]: {
            ...state.info[companyID],
            visitorLogEnabled: true,
          },
        },
      };
    },
    [disableVisitorLogSuccess](state, { payload: companyID }) {
      return {
        ...state,
        info: {
          ...state.info,
          [companyID]: {
            ...state.info[companyID],
            visitorLogEnabled: false,
          },
        },
      };
    },
    [enableSSOSuccess](state, { payload: companyID }) {
      return {
        ...state,
        info: {
          ...state.info,
          [companyID]: {
            ...state.info[companyID],
            ssoEnabled: true,
          },
        },
      };
    },
    [disableSSOSuccess](state, { payload: companyID }) {
      return {
        ...state,
        info: {
          ...state.info,
          [companyID]: {
            ...state.info[companyID],
            ssoEnabled: false,
          },
        },
      };
    },
    [ssoConfigurationSuccess](state, { payload: { companyID, payload } }) {
      return {
        ...state,
        sso: {
          ...state.sso,
          [companyID]: payload,
        },
      };
    },
    [updateSSOConfigurationSuccess](state, { payload: { companyID, payload } }) {
      return {
        ...state,
        sso: {
          ...state.sso,
          [companyID]: {
            ...state.sso[companyID],
            ...payload,
          },
        },
      };
    },
    [enableBranchesSuccess](state, { payload: companyID }) {
      return {
        ...state,
        info: {
          ...state.info,
          [companyID]: {
            ...state.info[companyID],
            branchesEnabled: true,
          },
        },
      };
    },
    [disableBranchesSuccess](state, { payload: companyID }) {
      return {
        ...state,
        info: {
          ...state.info,
          [companyID]: {
            ...state.info[companyID],
            branchesEnabled: false,
          },
        },
      };
    },
    [updateMaxShiftHoursSuccess](state, { payload: { companyID, maxShiftHours } }) {
      return {
        ...state,
        info: {
          ...state.info,
          [companyID]: {
            ...state.info[companyID],
            maxShiftHours,
          },
        },
      };
    },
    [switchGpsRequiredSuccess](state, { payload: { companyID, gpsRequiredDuringShift } }) {
      return {
        ...state,
        info: {
          ...state.info,
          [companyID]: {
            ...state.info[companyID],
            gpsRequiredDuringShift,
          },
        },
      };
    },
    [enableChatSuccess](state, { payload: companyID }) {
      return {
        ...state,
        info: {
          ...state.info,
          [companyID]: {
            ...state.info[companyID],
            chatEnabled: true,
          },
        },
      };
    },
    [disableChatSuccess](state, { payload: companyID }) {
      return {
        ...state,
        info: {
          ...state.info,
          [companyID]: {
            ...state.info[companyID],
            chatEnabled: false,
          },
        },
      };
    },
    [logoutSuccess]() {
      return initialState;
    },
  },
  initialState
);
